// TailorKit pricing page
// - Cost calculator: 2 cards (Starter / Growth) sync inputs + recommend banner
// - ROI calculator: revenue × fee − plan cost, animated counting, GTM tracking
(function () {
  var root = document.querySelector('.pricing-page');
  if (!root) return;

  // ══════════ Plan config (from data-attrs on root) ══════════
  var plans = {
    starter: {
      base: parseFloat(root.dataset.starterBase) || 19,
      free: parseInt(root.dataset.starterFree, 10) || 50,
      over: parseFloat(root.dataset.starterOver) || 0.5,
      label: 'Starter'
    },
    growth: {
      base: parseFloat(root.dataset.growthBase) || 49,
      free: parseInt(root.dataset.growthFree, 10) || 500,
      over: parseFloat(root.dataset.growthOver) || 0.1,
      label: 'Growth'
    }
  };

  // ══════════ Shared helpers ══════════

  // total = base + max(0, orders - free) * over
  function compute(plan, orders) {
    var extra = Math.max(0, orders - plan.free);
    var freeUsed = Math.min(plan.free, orders);
    var overage = extra * plan.over;
    return { total: plan.base + overage, extra: extra, freeUsed: freeUsed, overage: overage };
  }

  // USD-style format ($1,234.56) — used for cost calculator (plans billed in USD)
  function fmtUSD(n) {
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // Currency-aware formatter for ROI block (uses storefront currency from Liquid).
  // Keeps cents so overage like $0.10 is visible — rounding here would hide it.
  var currencyCode = (root.dataset.currency || 'USD').toUpperCase();
  var nfMoney;
  try {
    nfMoney = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode });
  } catch (e) {
    nfMoney = { format: function (n) { return fmtUSD(n); } };
  }
  function fmtCurrency(n) { return nfMoney.format(n); }

  // GTM dataLayer tracker — debounced per event name (1500ms after last call)
  var trackTimers = {};
  function track(eventName, props) {
    if (!window.dataLayer) window.dataLayer = [];
    clearTimeout(trackTimers[eventName]);
    trackTimers[eventName] = setTimeout(function () {
      window.dataLayer.push(Object.assign({ event: eventName }, props || {}));
    }, 1500);
  }

  // Animated number counter (cubic-out easing). Respects prefers-reduced-motion.
  var prefersReduced = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function animateNumber(el, from, to, formatter, duration) {
    if (!el) return;
    duration = duration || 700;
    if (prefersReduced || from === to) { el.textContent = formatter(to); return; }
    var start = performance.now();
    function frame(now) {
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      el.textContent = formatter(from + (to - from) * eased);
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  // ══════════ ROI calculator ══════════
  (function initRoi() {
    var card = root.querySelector('.roi-card');
    if (!card) return;

    var volumeInput = card.querySelector('#roi-volume');
    var feeInput    = card.querySelector('#roi-fee');
    var segBtns     = card.querySelectorAll('.roi-seg-btn');
    var revEl       = card.querySelector('[data-roi-revenue]');
    var planFeeEl   = card.querySelector('[data-roi-fee]');
    var feeDetailEl = card.querySelector('[data-roi-fee-detail]');
    var profitEl    = card.querySelector('[data-roi-profit]');
    var profitCta   = card.querySelector('[data-roi-profit-cta]');
    var profitCtaLabel = card.querySelector('[data-roi-profit-cta-label]');
    var profitCtaPrice = card.querySelector('[data-roi-profit-cta-price]');
    var recBox      = card.querySelector('#roi-recommend');
    if (!volumeInput || !feeInput || !revEl || !planFeeEl || !profitEl) return;

    // Set currency symbol prefix on the fee input (€, ¥, $, etc. depending on shop currency)
    var prefixEl = card.querySelector('[data-currency-symbol]');
    if (prefixEl) {
      var symbol = '$';
      try {
        var parts = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode })
          .formatToParts(0);
        for (var i = 0; i < parts.length; i++) {
          if (parts[i].type === 'currency') { symbol = parts[i].value; break; }
        }
      } catch (e) { /* keep default $ */ }
      prefixEl.textContent = symbol;
    }

    var currentPlan = 'growth';
    var last = { revenue: 0, planCost: 0, profit: 0 };
    var initialPaint = true;

    function paint() {
      var orders = parseInt(volumeInput.value, 10) || 0;
      var fee    = parseFloat(feeInput.value) || 0;
      var plan   = plans[currentPlan];
      var calc   = compute(plan, orders);
      var planCost = calc.total;
      var revenue  = orders * fee;
      var profit   = revenue - planCost;

      // Show overage breakdown when extra orders kick in
      if (feeDetailEl) {
        feeDetailEl.textContent = calc.extra > 0
          ? 'Base $' + plan.base + ' + ' + calc.extra.toLocaleString() +
            ' extra × $' + plan.over.toFixed(2)
          : '';
      }

      // Animate (or snap on first paint)
      var revFrom    = initialPaint ? revenue  : last.revenue;
      var feeFrom    = initialPaint ? planCost : last.planCost;
      var profitFrom = initialPaint ? profit   : last.profit;

      animateNumber(revEl, revFrom, revenue, fmtCurrency);
      animateNumber(planFeeEl, feeFrom, planCost, function (n) { return '−' + fmtCurrency(n); });
      animateNumber(profitEl, Math.max(0, profitFrom), Math.max(0, profit), function (n) {
        return fmtCurrency(n) + (profit > 0 ? ' 🚀' : '');
      });
      profitEl.classList.toggle('is-loss', profit <= 0);

      // Sync the always-visible inline CTA under the profit display with the
      // currently-selected plan. Disable when profit ≤ 0 — pushing install at a
      // loss feels tone-deaf; let the user adjust inputs first.
      if (profitCta) {
        var pp = plans[currentPlan];
        if (profitCtaLabel) profitCtaLabel.textContent = 'Start with ' + pp.label;
        if (profitCtaPrice) profitCtaPrice.textContent = '— $' + pp.base;
        profitCta.href = profitCta.href.replace(/utm_content=[^&]*/, 'utm_content=roi-profit-' + currentPlan);
        profitCta.classList.toggle('is-disabled', profit <= 0);
      }

      last = { revenue: revenue, planCost: planCost, profit: profit };
      initialPaint = false;

      // Smart auto-recommend banner — bidirectional based on active plan tab.
      // CONFIRM mode: active plan IS the cheaper one at current input.
      //   "At X orders × $Y fee, [Active Plan] saves $Z/mo vs the other plan."
      // EXAMPLE mode: active plan is more expensive — show projected savings
      //   at a "sweet spot" volume where active plan wins; "Try this" button
      //   populates that volume into the input.
      if (recBox && orders > 0 && fee > 0) {
        var starterCost = compute(plans.starter, orders).total;
        var growthCost  = compute(plans.growth, orders).total;
        var cheaper     = starterCost <= growthCost ? 'starter' : 'growth';
        var diff        = Math.abs(starterCost - growthCost);
        var p           = plans[currentPlan];
        var ctaEl       = recBox.querySelector('[data-rec-cta]');
        var tryEl       = recBox.querySelector('[data-rec-try]');
        var planEls     = recBox.querySelectorAll('[data-rec-plan]');

        if (currentPlan === cheaper && diff >= 5) {
          // CONFIRM mode
          recBox.dataset.mode = 'confirm';
          recBox.querySelector('[data-rec-orders]').textContent = orders.toLocaleString();
          recBox.querySelector('[data-rec-fee]').textContent = '$' + (fee % 1 ? fee.toFixed(2) : fee.toFixed(0));
          planEls.forEach(function (el) { el.textContent = p.label; });
          recBox.querySelector('[data-rec-savings]').textContent = fmtUSD(diff) + '/mo';
          ctaEl.textContent = 'Get ' + p.label + ' →';
          ctaEl.href = ctaEl.href.replace(/utm_content=[^&]*/, 'utm_content=roi-rec-' + currentPlan);
          tryEl.dataset.tryVolume = '';
          recBox.hidden = false;
        } else if (currentPlan !== cheaper) {
          // EXAMPLE mode — pick a volume where active plan would win.
          // Breakeven Starter↔Growth at fee-independent point: ~110 orders.
          // Use a clear "sweet-spot" example: 200 for Growth, 30 for Starter.
          var exampleOrders = currentPlan === 'growth' ? 200 : 30;
          var exStarter = compute(plans.starter, exampleOrders).total;
          var exGrowth  = compute(plans.growth, exampleOrders).total;
          var exDiff = currentPlan === 'growth'
            ? Math.max(0, exStarter - exGrowth)
            : Math.max(0, exGrowth - exStarter);

          if (exDiff >= 5) {
            recBox.dataset.mode = 'example';
            recBox.querySelector('[data-rec-example-orders]').textContent = exampleOrders.toLocaleString();
            planEls.forEach(function (el) { el.textContent = p.label; });
            recBox.querySelector('[data-rec-example-savings]').textContent = fmtUSD(exDiff) + '/mo';
            ctaEl.textContent = 'Get ' + p.label + ' →';
            ctaEl.href = ctaEl.href.replace(/utm_content=[^&]*/, 'utm_content=roi-rec-example-' + currentPlan);
            tryEl.dataset.tryVolume = exampleOrders;
            recBox.hidden = false;
          } else {
            recBox.hidden = true;
          }
        } else {
          recBox.hidden = true;
        }
      } else if (recBox) {
        recBox.hidden = true;
      }

      // GTM tracking (debounced 1500ms)
      track('pricing_calculator_used', {
        section: 'roi', plan: currentPlan, orders: orders, fee: fee
      });
      track('pricing_roi_calculator_used', {
        plan: currentPlan, orders: orders, fee: fee,
        revenue: +revenue.toFixed(2),
        plan_cost: +planCost.toFixed(2),
        net_profit: +profit.toFixed(2),
        currency: currencyCode
      });
    }

    volumeInput.addEventListener('input', paint);
    feeInput.addEventListener('input', paint);

    // "Try this" button in example-mode banner — sets volume to suggested example
    var tryBtn = card.querySelector('[data-rec-try]');
    if (tryBtn) {
      tryBtn.addEventListener('click', function () {
        var v = parseInt(tryBtn.dataset.tryVolume, 10);
        if (!v) return;
        volumeInput.value = v;
        paint();
        track('pricing_roi_try_example', { suggested_orders: v, plan: currentPlan });
      });
    }

    segBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        currentPlan = btn.dataset.plan;
        segBtns.forEach(function (x) {
          var active = x === btn;
          x.classList.toggle('is-active', active);
          x.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        paint();
      });
    });

    // ICP preset tabs — when user clicks Jewelry/Leather/Gifts, pre-fill volume + fee
    // with realistic typical values for that industry. Track each preset for analytics.
    var icpTabs = card.querySelectorAll('.roi-icp-tab');
    icpTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        icpTabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        var orders = parseInt(tab.dataset.orders, 10) || 0;
        var fee = parseFloat(tab.dataset.fee) || 0;
        volumeInput.value = orders;
        feeInput.value = fee;
        paint();
        track('pricing_roi_icp_selected', { icp: tab.dataset.icp, orders: orders, fee: fee });
      });
    });

    paint();
  })();

  // ══════════ Smooth scroll (Lenis) ══════════
  // Lenis gives weighty inertia scrolling. Disabled on touch devices (native momentum
  // is already great there) and when user prefers reduced motion.
  // Anchor link clicks are routed through lenis.scrollTo so they animate consistently
  // and respect the sticky-subnav offset.
  var lenis = null;
  (function initSmoothScroll() {
    var isTouch = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (isTouch || prefersReduced || !window.Lenis) return;

    lenis = new window.Lenis({
      duration: 1.4,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      wheelMultiplier: 0.85,
      touchMultiplier: 1
    });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);

    // Route in-page anchor clicks through Lenis so the easing matches the rest
    // of the page (native scrollTo would snap or jitter against Lenis).
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href === '#' || href.length < 2) return;
      var target = document.getElementById(href.slice(1));
      if (!target) return;
      e.preventDefault();
      lenis.scrollTo(target, { offset: -72, duration: 1.0 });
      // Update URL hash without an extra scroll jump
      if (history.replaceState) history.replaceState(null, '', href);
    });
  })();

  // ══════════ Reveal-on-scroll ══════════
  // Each [data-reveal] element fades + slides up 16px when it enters the viewport.
  // One-shot: once revealed, the observer stops watching that element (no re-trigger
  // on scroll-up — feels less twitchy).
  (function initReveal() {
    var els = root.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    var prefersReduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    // Bi-directional reveal — element fades in when entering the upper 85% of
    // viewport (rootMargin shrinks bottom 15%), fades out when leaving. This way
    // anchor jumps and back-to-top scrolls re-trigger the animation each time.
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('is-revealed', entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -15% 0px', threshold: 0 });
    els.forEach(function (el) { observer.observe(el); });
  })();

  // ══════════ Sticky sub-nav: show/hide + scrollspy ══════════
  // Reveals the sub-nav after the hero scrolls out of view, and highlights
  // the link matching the section currently in the upper-middle of the viewport.
  (function initSubnav() {
    if (!('IntersectionObserver' in window)) return;
    var subnav = root.querySelector('.pricing-subnav');
    var hero   = root.querySelector('.hero');
    if (!subnav || !hero) return;

    // 1) Toggle visibility based on hero presence in viewport
    new IntersectionObserver(function (entries) {
      subnav.setAttribute('data-visible', entries[0].isIntersecting ? 'false' : 'true');
    }, { threshold: 0 }).observe(hero);

    // 2) Scrollspy — track which section[id] is currently centered
    var spyLinks = subnav.querySelectorAll('[data-spy]');
    if (!spyLinks.length) return;
    var idToLink = {};
    spyLinks.forEach(function (a) { idToLink[a.getAttribute('data-spy')] = a; });

    var sections = root.querySelectorAll('section[id]');
    var visibleIds = new Set();

    var spyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var id = entry.target.id;
        if (entry.isIntersecting) visibleIds.add(id);
        else visibleIds.delete(id);
      });
      // Pick the topmost visible section as the active one
      var activeId = null;
      for (var i = 0; i < sections.length; i++) {
        if (visibleIds.has(sections[i].id)) { activeId = sections[i].id; break; }
      }
      spyLinks.forEach(function (a) {
        a.classList.toggle('is-active', a.getAttribute('data-spy') === activeId);
      });
    }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

    sections.forEach(function (s) { spyObserver.observe(s); });
  })();

  // ══════════ Plan recommender wizard ══════════
  // 3-question modal that recommends Starter or Growth based on:
  // - orders (>50 → Growth lean), - industry (luxury/jewelry → Growth),
  // - SVG export need (yes → Growth required).
  (function initRecommender() {
    var dialog = document.getElementById('planRecommender');
    var openers = root.querySelectorAll('[data-recommender-open]');
    var closers = root.querySelectorAll('[data-recommender-close]');
    var restart = root.querySelector('[data-recommender-restart]');
    var backBtn = dialog && dialog.querySelector('[data-recommender-back]');
    if (!dialog || !openers.length) return;

    var answers = { orders: null, industry: null, svg: null };
    var stepKeys = ['orders', 'industry', 'svg']; // order matches step numbers
    var currentStep = 1;
    var totalSteps = 3;
    var steps = dialog.querySelectorAll('.recommender-step');
    var progressBar = dialog.querySelector('[data-rec-progress]');

    function showStep(stepKey) {
      steps.forEach(function (s) {
        s.classList.toggle('is-active', s.dataset.step === String(stepKey));
      });
      if (typeof stepKey === 'number') {
        progressBar.style.width = (stepKey / totalSteps * 100) + '%';
        // Show Back button on Q2+, hide on Q1
        if (backBtn) backBtn.hidden = (stepKey <= 1);
      } else if (stepKey === 'result') {
        progressBar.style.width = '100%';
        if (backBtn) backBtn.hidden = true;
      }
    }

    function reset() {
      answers = { orders: null, industry: null, svg: null };
      currentStep = 1;
      showStep(1);
      dialog.querySelectorAll('.recommender-opt').forEach(function (b) {
        b.classList.remove('is-selected');
      });
    }

    function goBack() {
      if (currentStep <= 1) return;
      // Clear current step's answer so user can re-pick freely
      var prevKey = stepKeys[currentStep - 2]; // -1 for index, -1 for previous
      // Actually clear the answer for the step we're LEAVING (current step's question)
      // and reset selected state on its options
      var leavingKey = stepKeys[currentStep - 1];
      if (leavingKey) answers[leavingKey] = null;
      currentStep--;
      // Clear is-selected from the step we're going BACK to so user re-picks
      var goingToStep = dialog.querySelector('.recommender-step[data-step="' + currentStep + '"]');
      goingToStep && goingToStep.querySelectorAll('.recommender-opt').forEach(function (b) {
        b.classList.remove('is-selected');
      });
      showStep(currentStep);
    }
    backBtn && backBtn.addEventListener('click', goBack);

    function recommend() {
      // Decision rule:
      // - SVG yes → Growth (lossless export only on Growth)
      // - Orders 200-500 or 500+ → Growth
      // - Orders 50-200 + jewelry/leather (low-volume but high-value) → consider Growth
      // - Otherwise → Starter
      var plan = 'starter';
      var why = '';

      if (answers.svg === 'yes') {
        plan = 'growth';
        why = 'You need lossless SVG export — that\'s only on Growth, plus the headroom in orders and AI credits will keep you covered as you scale.';
      } else if (answers.orders === '200-500' || answers.orders === '500+') {
        plan = 'growth';
        why = 'At your volume, Growth\'s 500 free orders + lower overage ($0.10) saves money vs Starter, plus you get unlimited upsell products.';
      } else if (answers.orders === '50-200' && (answers.industry === 'jewelry' || answers.industry === 'leather')) {
        plan = 'growth';
        why = 'Premium jewelry and leather goods benefit from unlimited upsells and lossless export — Growth gives you headroom to scale without re-platforming.';
      } else {
        plan = 'starter';
        why = 'You\'re testing the waters — Starter\'s 50 free orders and core personalization toolkit is enough to validate before scaling up.';
      }

      var p = plan === 'growth'
        ? { name: 'Growth', price: 49, meta: '500 free orders, then $0.10 per extra order' }
        : { name: 'Starter', price: 19, meta: '50 free orders, then $0.50 per extra order' };

      dialog.querySelector('[data-rec-name]').textContent = p.name;
      dialog.querySelector('[data-rec-price]').textContent = p.price;
      dialog.querySelector('[data-rec-meta]').textContent = p.meta;
      dialog.querySelector('[data-rec-why]').textContent = why;
      var installEl = dialog.querySelector('[data-rec-install]');
      installEl.href = installEl.href.replace(/utm_content=[^&]*/, 'utm_content=recommender-' + plan);
      installEl.textContent = 'Install TailorKit ' + p.name + ' →';

      track('pricing_plan_recommender_completed', {
        recommended_plan: plan,
        answer_orders: answers.orders,
        answer_industry: answers.industry,
        answer_svg: answers.svg
      });

      showStep('result');
    }

    function open() {
      reset();
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      track('pricing_plan_recommender_opened', {});
    }
    function close() {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    restart && restart.addEventListener('click', reset);

    // Click outside dialog content closes
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) close();
    });

    // Option clicks — flash selected state, then advance to next step.
    // The brief delay (280ms) gives clear visual feedback so the user feels
    // their tap registered before the modal switches questions.
    dialog.querySelectorAll('.recommender-opt').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var q = btn.dataset.q;
        var v = btn.dataset.val;
        if (!q || !v) return;
        // Clear sibling selected states, then mark this one
        var siblings = btn.parentElement.querySelectorAll('.recommender-opt');
        siblings.forEach(function (s) { s.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        answers[q] = v;
        // Brief delay before advancing — user sees ✓ confirmation
        setTimeout(function () {
          currentStep++;
          if (currentStep > totalSteps) recommend();
          else showStep(currentStep);
        }, 280);
      });
    });
  })();

  // ══════════ Intercom live-chat trigger (CSP-safe replacement for inline onclick) ══════════
  (function initIntercomLink() {
    root.querySelectorAll('[data-intercom-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (window.Intercom) { e.preventDefault(); window.Intercom('show'); }
      });
    });
  })();

  // ══════════ Sticky bottom CTA bar ══════════
  // Slides up after plan cards exit viewport, hides when final CTA section
  // enters viewport (so it doesn't compete with the dedicated banner).
  (function initStickyCta() {
    if (!('IntersectionObserver' in window)) return;
    var bar = root.querySelector('.pricing-stickycta');
    var plansSection = root.querySelector('#plans');
    var finalCta = root.querySelector('.cta-section');
    if (!bar || !plansSection) return;

    var plansVisible = true;   // start true — we don't want bar visible at top
    var finalVisible = false;

    function update() {
      // Show bar when plans NOT visible (scrolled past) AND final CTA NOT visible (not at bottom yet)
      bar.setAttribute('data-visible', (!plansVisible && !finalVisible) ? 'true' : 'false');
    }

    new IntersectionObserver(function (entries) {
      plansVisible = entries[0].isIntersecting;
      update();
    }, { threshold: 0 }).observe(plansSection);

    if (finalCta) {
      new IntersectionObserver(function (entries) {
        finalVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(finalCta);
    }
  })();

  // ══════════ "See all features" toggle ══════════
  (function initFeaturesMore() {
    var toggle = root.querySelector('.features-more-toggle');
    var content = root.querySelector('.features-more-content');
    if (!toggle || !content) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      content.setAttribute('data-open', open ? 'false' : 'true');
      toggle.textContent = open ? 'See all features' : 'Hide all features';
    });
  })();
})();
